import app from './../../../app';
import _ from './../../../libs/lodash';
import helperDate from './../../../helpers/dateFormats';
import helperTimeIntervals from './../../../helpers/timeIntervals';
import projectsModel from './../../../models/projects';
import templates from './../../../templates/labels';

const __ = window.__;

var innerSettings = {
  workDays: [],
  workHours: []
};

var innerConst = {
  startOnMonday: [
    {id: 1, value: __("common_short_mon")},
    {id: 2, value: __("common_short_tue")},
    {id: 3, value: __("common_short_wed")},
    {id: 4, value: __("common_short_thu")},
    {id: 5, value: __("common_short_fri")},
    {id: 6, value: __("common_short_sat")},
    {id: 7, value: __("common_short_sun")}
  ],
  startOnSunday: [
    {id: 7, value: __("common_short_sun")},
    {id: 1, value: __("common_short_mon")},
    {id: 2, value: __("common_short_tue")},
    {id: 3, value: __("common_short_wed")},
    {id: 4, value: __("common_short_thu")},
    {id: 5, value: __("common_short_fri")},
    {id: 6, value: __("common_short_sat")}
  ]
};

var innerViews = {
  daysRangeLabel: {
    view: "label",
    id: "daysRangeLabelNewProject",
    width: 160,
    label: __("project_settings_days"),
    css: "label-with-spacer",
    template: templates.getTemplateForLabelWithSpacerAndNumber,
    toolTip: {
      y: 4,
      langKey: "project_settings_range_days_tooltip"
    }
  },
  displayOptionsListDays: {
    view: "daysList",
    id: "displayOptionsListDaysNewProject",
    label: __("settings_day_popup"),
    height: 44,
    type: {
      width: 74,
      height: 42
    },
    on: {
      "onSelectChange": function () {
        innerHandlers.changeDays(this);
      },
    }
  },
  workHoursPopup: {
    id: "workHoursPopupNewProject",
    css: "workHoursPopupNewProject"
  },
  hoursRangeLabel: {
    view: "template",
    id: "displayOptionRangeHoursLabelNewProject",
    height: 44,
    css: "hours-template gp_autotest_calendar_settings_hours_select",
    intervals: [],
    borderless: false,
    template: function (obj) {
      var innerHtml = "";

      this.intervals.forEach(function (intervalString) {
        innerHtml += "<div class='dataview-hours-inline-item gp_autotest_calendar_settings_hours_item'>" + intervalString + "</div>";
      });

      return "<div class='dataview-hours-inline'>" + innerHtml + "</div>";
    },
    onClick: {
      "hours-template": function () {
        $$(innerViews.workHoursPopup.id).toggle(this.$view, {y: -2});
      }
    }
  },
  optionsHoursLabel: {
    view: "label",
    id: "optionsHoursLabelNewProject",
    align: "center",
    label: __("hours_label_desc_in_data_view")
  },
  hoursRangeTitleLabel: {
    view: "label",
    id: "displayOptionRangeHoursTitleLabelNewProject",
    width: 160,
    label: __("project_settings_hours"),
    css: "label-with-spacer",
    toolTip: {
      y: 4,
      langKey: "project_settings_range_hours_tooltip"
    },
    number: 0,
    template: templates.getTemplateForLabelWithSpacerAndNumber,
  },
  displayOptionsHoursDataView: {
    view: "dataview",
    id: "displayOptionsHoursDataViewNewProject",
    select: true,
    multiselect: "touch",
    xCount: 6,
    yCount: 4,
    scroll: false,
    align: "center",
    css: "dataview-hours displayOptionsHoursDataView",
    type: {
      width: 92,
      height: 40
    },
    data: [],
    on: {
      "onSelectChange": function () {
        innerHandlers.changeHours();
      }
    },
    template: function (obj) {
      return "<div class='dataview-hours-item gp_autotest_calendar_settings_hours_list_item'>" + obj.value + "</div>";
    }
  },
};

var innerHandlers = {
  init: function () {
    innerSettings.workDays = projectsModel.getDefaultWorkDays();
    innerSettings.workHours = projectsModel.getDefaultworkHours();

    innerHandlers.initListDays(+user.settings.start_monday);
    innerHandlers.initWorkHours();
  },
  initListDays: function (startOnMonday) {
    var webixDayUI = $$(innerViews.displayOptionsListDays.id);

    if (webixDayUI) {
      webixDayUI.clearAll();
      startOnMonday ? webixDayUI.parse(innerConst.startOnMonday) : webixDayUI.parse(innerConst.startOnSunday);

      webixDayUI.unselectAll();
      webixDayUI.blockEvent();
      webixDayUI.select(innerSettings.workDays);
      webixDayUI.unblockEvent();

      innerHandlers.updateNumberInDaysLabel();
    }
  },
  initWorkHours: function () {
    var selectedHoursByIntervals = [];
    var hour = 0;

    $$(innerViews.displayOptionsHoursDataView.id).parse(helperDate.getHoursArrayByUserTimeFormat());
    $$(innerViews.displayOptionsHoursDataView.id).blockEvent();

    for (var i = 0; i < innerSettings.workHours.length; i = i + 2) {
      for (hour = innerSettings.workHours[i]; hour < innerSettings.workHours[i + 1]; hour++) {
        if (!hour) {
          hour = "0";
        }
        selectedHoursByIntervals.push(hour);
      }
    }

    $$(innerViews.hoursRangeTitleLabel.id).config.number = selectedHoursByIntervals.length + ' ' + __('h');
    $$(innerViews.displayOptionsHoursDataView.id).select(selectedHoursByIntervals);
    $$(innerViews.displayOptionsHoursDataView.id).unblockEvent();
    innerHandlers.updateHoursLabels();
  },
  changeDays: function () {
    var webixDayUI = $$(innerViews.displayOptionsListDays.id);
    var selectedDays = webixDayUI.getSelectedId();

    if (typeof selectedDays === "number" || _.toSafeInteger(selectedDays)) {
      selectedDays = [selectedDays];
    }

    if (typeof selectedDays === "string") {
      selectedDays = [];
    }

    selectedDays = selectedDays
      .sort(function (a, b) {
        return a - b;
      })
      .map(function (dayNumber) {
        return parseInt(dayNumber, 10);
      });

    if (!selectedDays.length) {
      webixDayUI.blockEvent();
      webixDayUI.selectAll();
      selectedDays = webixDayUI.getSelectedId();
      webixDayUI.unblockEvent();
    }

    innerSettings.startDay = selectedDays[0];
    innerSettings.endDay = selectedDays[selectedDays.length - 1];
    innerSettings.workDays = selectedDays;
    innerHandlers.updateNumberInDaysLabel();
    app.trigger('newProject:updateWorkDays', innerSettings.workDays);
  },
  updateNumberInDaysLabel: function () {
    var webixUI = $$(innerViews.daysRangeLabel.id);

    webixUI.config.number = innerSettings.workDays.length + ' ' + __('d');
    webixUI.refresh();
  },
  updateHoursLabels: function () {
    var delimiter = ";";
    var stringIntervals = innerHelpers.getLabelForIntervals(null, delimiter);
    var hoursIntervals = stringIntervals.split(delimiter);
    var hoursRangeLabel = $$(innerViews.hoursRangeLabel.id);
    var titleView = $$(innerViews.hoursRangeTitleLabel.id);
    var selectedHours = $$(innerViews.displayOptionsHoursDataView.id).getSelectedId();
    var popup = $$(innerViews.workHoursPopup.id);

    titleView.config.number = (selectedHours && typeof selectedHours !== 'string' && selectedHours.length > 0 ? selectedHours.length : 1) + ' ' + __('h');
    titleView.refresh();

    hoursRangeLabel.config.intervals = hoursIntervals;
    hoursRangeLabel.config.height = 40 * Math.ceil(hoursIntervals.length / 4) + 6;
    hoursRangeLabel.resize();
    hoursRangeLabel.refresh();

    if (popup.isVisible()) {
      popup.show(hoursRangeLabel.getNode(), {y: -2});
    }
  },
  showHoursList: function () {
    var oldSelect = $$(innerViews.displayOptionsHoursDataView.id).getSelectedId();
    var optionsHoursDataView = $$(innerViews.displayOptionsHoursDataView.id);

    optionsHoursDataView.blockEvent();
    optionsHoursDataView.clearAll();
    optionsHoursDataView.parse(helperDate.getHoursArrayByUserTimeFormat());
    optionsHoursDataView.select(oldSelect);
    optionsHoursDataView.unblockEvent();
  },
  changeHours: function (blockSend) {
    var optionsHoursDataView = $$(innerViews.displayOptionsHoursDataView.id);
    var selectedHours = optionsHoursDataView.getSelectedId();
    var showTimesIntervals = helperTimeIntervals.prepareSelectedHours(selectedHours);

    if (!showTimesIntervals.length) {
      showTimesIntervals = [9, 13, 14, 18];
      optionsHoursDataView.blockEvent();
      optionsHoursDataView.select([9, 10, 11, 12, 14, 15, 16, 17]);
      optionsHoursDataView.unblockEvent();
      optionsHoursDataView.callEvent("onSelectChange", []);
    }

    innerSettings.workHours = webix.copy(showTimesIntervals);

    innerHandlers.updateHoursLabels();
  },
  getWorkDays: function () {
    return innerSettings.workDays;
  },
  getWorkHours: function () {
    return innerSettings.workHours;
  }
};

var innerHelpers = {
  hour24toAMPM: function (digitHour) {
    var timeCorrector = 0,
      AMPM = "AM";

    if (digitHour === 0) {
      timeCorrector = -12;
    }

    if (digitHour === 12) {
      timeCorrector = 0;
      AMPM = "PM";
    }
    if (digitHour > 12) {
      timeCorrector = 12;
      AMPM = "PM";
    }
    if (digitHour === 24) {
      return "12 AM";
    }

    return (digitHour - timeCorrector + AMPM);
  },
  getLabelForIntervals: function (currentHoursArray, delimiter) {
    var labelWithIntervals = "";
    var AMPM = "";
    var enableAM = !helperDate.getUserTimeFormat();
    var timeCorrector = 0;
    var labelDelimiter = delimiter ? delimiter : ",&nbsp;&nbsp;&nbsp;";
    var hoursArray = innerSettings.workHours;
    var i = 0;

    if (currentHoursArray) {
      hoursArray = currentHoursArray;
    }

    for (i = 0; i < hoursArray.length; i = i + 2) {

      if (enableAM) {
        labelWithIntervals +=
          innerHelpers.hour24toAMPM(hoursArray[i]) + " - " +
          innerHelpers.hour24toAMPM(hoursArray[i + 1]) + labelDelimiter;

      } else {
        labelWithIntervals += hoursArray[i] + ":00 - " +
          hoursArray[i + 1] + ":00" + labelDelimiter;
      }

    }
    return labelWithIntervals.slice(0, labelWithIntervals.length - labelDelimiter.length);
  },
};

webix.ui({
  view: "popupWith6Padding",
  id: innerViews.workHoursPopup.id,
  css: innerViews.workHoursPopup.css,
  padding: 8,
  width: 568,
  body: {
    type: "clean",
    paddingX: 0,
    paddingY: 0,
    borderless: true,
    rows: [
      innerViews.displayOptionsHoursDataView,
      // {width: 568},
      innerViews.optionsHoursLabel
    ]
  },
  on: {
    'onShow': function () {
      innerHandlers.showHoursList();
    }
  }
}).hide();

var outputObject = {
  init: innerHandlers.init,
  view: {
    css: 'calendar_settings',
    rows: [
      {
        //width: "100%",
        rows: [
          innerViews.daysRangeLabel,
          innerViews.displayOptionsListDays
        ]
      },
      {height: 10},
      {
        //width: "100%",
        rows: [
          innerViews.hoursRangeTitleLabel,
          innerViews.hoursRangeLabel
        ]
      }
    ]
  },
  handlers: {
    getWorkDays: innerHandlers.getWorkDays,
    getWorkHours: innerHandlers.getWorkHours
  }
};


app.on("settings:startOnMonday:change", function (startOnMonday) {
  // if ($$('workHoursPopupNewProject') && $$('workHoursPopupNewProject').isVisible()) {
    innerHandlers.initListDays(startOnMonday);
  // }
});

export default outputObject;
